export default "__VITE_ASSET__e110cd69__"